<template>
    <div class='demo'>
      <van-button type="info" @click="gotoWx" block>关注公众号</van-button>
      <wx-open-audio
      
      title="追光者"
      singer="追光者"
      episode="追光者"
      src="https://o-yzx.bysjy.com.cn/yxdczh0000000186/mates/202104/yxz607f9f6a193b8.mp3"
      cover="https://o-yzx.bysjy.com.cn/yxdczh0000000186/mates/202101/yxz5ffbb04bcc842.png"
    ></wx-open-audio>

    </div>
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import login from '@/components/common/login';
import wx from 'weixin-js-sdk'

export default {
        name: "index",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                bodyShow: false,
                playList:[],
                sectionList:[],
            }
        },
        mounted() {
            // this.util.hideOptionMenu()
            this.init()
            this.$(document).attr('title','测试')
            console.log("父组件")
            var list = [4,5,6]
            this.playList = list
            this.sectionList = list
            this.init()
        },
        methods:{
            init(){
                this.sectionList.splice(1,1)
                console.log(this.playList)
                this.util.jweixin(function (wx) {
                    
                });
            },
            gotoWx(){
              window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzODU4NzkyOQ==&scene=110#wechat_redirect"
            }
        }
    }

</script>
